import { atom } from "jotai";

import type { AddressBookMode } from "../types";
import { addressBookAtom } from "./state";

export const modeAtom = atom(
  (get) => get(addressBookAtom).mode,
  (_get, set, value: AddressBookMode) => {
    set(addressBookAtom, (draft) => {
      draft.mode = value;
    });
  },
);

export const isEditModeAtom = atom((get) => get(modeAtom) === "edit");
